import { useIntl } from 'react-intl';
import { Comment, Profile, Map, FileSettings, LightBulbOutline, Comment2 } from '@clds/icon';
import { HorizontalSeparator } from '@clds/separator';
import { SystemStatusDot } from '@cld/system-status-dot';
import { AnalyticsWrapper } from '@cld/analytics';
import { DropdownMenuItemInNewTab } from '../../components/DropdownMenuItem';
import {
  ALL_SYSTEMS_OPERATIONAL_PAGE_URL,
  BLOG_PAGE_URL,
  DOCUMENTATION_PAGE_URL,
  MENU_ITEM_ICON_SIZE,
  TRAINING_PAGE_URL,
  CLOUDINARY_SUPPORT,
  PM_RELEASE_NOTES,
  DAM_RELEASE_NOTES,
} from '../../ApplicationWrapper.const';
import { messages } from '../../i18n';
import { useUserData } from '../../context';
import { useApplicationWrapperContext } from '../../context/applicationWrapper/ApplicationWrapper.context';
import { FeedbackButton } from '../FeedbackButton/FeedbackButton';

export const HelpDropdownMenuItems = ({ isMobile = false }) => {
  const { formatMessage } = useIntl();
  const { userData: user } = useUserData();
  const { selectedAppId } = useApplicationWrapperContext();

  const releaseNotes =
    selectedAppId === 'nexus' || selectedAppId === 'digital_asset_management' || selectedAppId === 'cloudinary_assets'
      ? DAM_RELEASE_NOTES
      : PM_RELEASE_NOTES;

  return (
    <AnalyticsWrapper category="help menu">
      <DropdownMenuItemInNewTab
        data-test-specifier="documentation link"
        analyticsMessage="documentation"
        leftSlot={<FileSettings size={MENU_ITEM_ICON_SIZE} />}
        href={DOCUMENTATION_PAGE_URL}
      >
        {formatMessage(messages.helpDocumentation)}
      </DropdownMenuItemInNewTab>
      <HorizontalSeparator />
      <DropdownMenuItemInNewTab
        data-test-specifier="Get support"
        analyticsMessage="ask a question"
        leftSlot={<Comment size={MENU_ITEM_ICON_SIZE} />}
        href={`${CLOUDINARY_SUPPORT}`}
      >
        {formatMessage(messages.helpAskAQuestion)}
      </DropdownMenuItemInNewTab>
      <DropdownMenuItemInNewTab
        data-test-specifier="release notes link"
        analyticsMessage="release notes"
        leftSlot={<LightBulbOutline size={MENU_ITEM_ICON_SIZE} />}
        href={releaseNotes}
      >
        {formatMessage(messages.helpReleaseNotes)}
      </DropdownMenuItemInNewTab>
      <DropdownMenuItemInNewTab
        data-test-specifier="blog link"
        analyticsMessage="blog"
        leftSlot={<Comment2 size={MENU_ITEM_ICON_SIZE} />}
        href={BLOG_PAGE_URL}
      >
        {formatMessage(messages.helpBlog)}
      </DropdownMenuItemInNewTab>
      <DropdownMenuItemInNewTab
        data-test-specifier="training courses link"
        analyticsMessage="training courses"
        leftSlot={<Profile size={MENU_ITEM_ICON_SIZE} />}
        href={TRAINING_PAGE_URL}
      >
        {formatMessage(messages.helpTrainingCourses)}
      </DropdownMenuItemInNewTab>
      {!isMobile && <FeedbackButton />}
      <HorizontalSeparator />
      <DropdownMenuItemInNewTab
        data-test-specifier="system status link"
        analyticsMessage="system status"
        leftSlot={<SystemStatusDot />}
        href={ALL_SYSTEMS_OPERATIONAL_PAGE_URL}
      >
        {formatMessage(messages.helpSystemStatus)}
      </DropdownMenuItemInNewTab>
    </AnalyticsWrapper>
  );
};
